import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de création d'un agent de vente d'un marchand
 * (`POST /MerchantSalesAgents/merchant/{merchantId}/add`).
 */
export const createMerchantSalesAgentSchema = () =>
  z.object({
    storeId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal(""))
      .optional(),
    partyId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    keycloakUserId: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") })
      .uuid({ message: t("invalidFieldError") }),
    fullName: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
  });

export type MerchantSalesAgentFormValues = z.infer<
  ReturnType<typeof createMerchantSalesAgentSchema>
>;
